"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _finance = require("@/api/finance");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// import parser from '@/components/FormGenerator/components/parser/ZBParser'
// 权限判断函数
var _default = exports.default = {
  // components: { parser },
  data: function data() {
    return {
      formConf: {
        fields: []
      },
      loading: false,
      keyNum: 0,
      editData: {},
      isCreate: 0,
      formName: '商户结算设置',
      ruleForm: {
        merchantShareFreezeTime: 7,
        merchantShareNode: 'complete'
      }
    };
  },
  created: function created() {
    //this.keyNum += 1
    this.getConfigInfo();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handlerSubmit: (0, _validate.Debounce)(function (formValue) {
      var _this = this;
      if ((0, _permission.checkPermi)(['platform:finance:merchant:closing:config:edit'])) {
        (0, _finance.closingEditApi)(formValue).then(function (res) {
          _this.$message.success('操作成功');
          _this.getConfigInfo();
        }).catch(function () {
          _this.loading = false;
        });
      } else {
        this.$message.warning('暂无操作权限');
      }
    }),
    // 获取转账配置信息
    getConfigInfo: function getConfigInfo() {
      var _this2 = this;
      this.keyNum += 1;
      this.loading = true;
      (0, _finance.closingConfigApi)().then(function (res) {
        for (var key in res) {
          if (res[key] === 'merchantShareNode') res[key] = parseFloat(res[key]);
        }
        _this2.editData = res;
        _this2.isCreate = 1;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};